// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b804caed","98":"985a88af","142":"edac549e","199":"00b709ee","725":"b3531fb9","745":"4dd91178","864":"6ab86bb3","891":"d138419b"}[chunkId] + ".chunk.js";
};